import { pick } from '@eastcoal/common/utils/object'

import { Klass, LexicalNode } from '@eastcoal/editor/exports'
import { useMutationListener } from '@eastcoal/editor/hooks/useMutationListener'

import { useContractDesignerStore } from '../../Store/hooks/useStore'

/**
 * 监听模板变量节点的变化
 *
 * @param nodeType lexical node 类型
 */
export const useListenVariableNodeChange = (nodeType: Klass<LexicalNode>) => {
  const { addUsedNodeKeys, removeUsedNodeKeys } = useContractDesignerStore(
    state => pick(state, ['addUsedNodeKeys', 'removeUsedNodeKeys'])
  )

  useMutationListener(nodeType, 'created', nodeKey => {
    addUsedNodeKeys(nodeKey)
  })
  useMutationListener(nodeType, 'destroyed', nodeKey => {
    removeUsedNodeKeys(nodeKey)
  })
}
